.logo {
  position: absolute;
  left: 15px;
  top: 19px;
  z-index: 10000;

  &.center {
    left: calc((100% - 337px) / 2);
    transform: translateX(-50%);
    top: 30px;
  }
}
